<template>
    <div id="comparison" class="d-none d-lg-flex">
        <section id="comparison-section">
            <div class="container">
                <div class="row justify-content-center text-center">
                    <div class="col-12">
                        <div class="intro-message" data-aos="fade-up" data-aos-duration="1200">
                            <span class="section-title mb-5">We Already Did The Research For You</span>
                            <div class="row justify-content-center align-self-center">
                                <div class="col-4"></div>
                                <div class="col-8">
                                    <div class="row">
                                        <div class="col">
                                            <span class="text-uppercase">spiritt</span>
                                        </div>
                                        <div class="col">
                                            <span class="text-uppercase">wix</span>
                                        </div>
                                        <div class="col">
                                            <span class="text-uppercase">wordpress</span>
                                        </div>
                                        <div class="col">
                                            <span class="text-uppercase">devshop</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="subjects && subjects.length" class=" h-100">
                                <div v-for="(subject, i) in subjects" :key="i" class="row">
                                    <div class="col-4 px-0">
                                        <div class="table-element table-statement">
                                            <span>{{ subject }}</span>
                                        </div>
                                    </div>
                                    <div class="col-8 px-0">
                                        <div class="row  align-items-center h-100">
                                            <div class="col px-0">
                                                <div class="table-element table-positive">
                                                    <img src="" alt="V" class="m-auto">
                                                </div>
                                            </div>
                                            <div class="col px-0">
                                                <div class="table-element table-negative">
                                                    <img src="" alt="X" class="m-auto">
                                                </div>
                                            </div>
                                            <div class="col px-0">
                                                <div class="table-element table-negative">
                                                    <img src="" alt="X" class="m-auto">
                                                </div>
                                            </div>
                                            <div class="col px-0">
                                                <div class="table-element table-negative">
                                                    <img src="" alt="X" class="m-auto">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'comparison',
        data () {
            return {
                subjects: [
                    'Peace of Mind - you only buy the ring once you’re 100% satisfied with the final product.',
                    'We guarantee that all our diamonds are eco-friendly, conflict-free and no child labor according to RJC Co …',
                    'Guarantees personal, tailor-made guidance, jeweler expertise and service.',
                    'Feel & Touch the engagement ring before buying.',
                ],
            }
        },
    }
</script>

<style lang="css" scoped>
    #comparison-section {
        background-color: #fff;
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .section-title {
        font-size: 35px;
        font-weight: 300;
        line-height: 1;
        width: 100%;
        display: block;
        text-align: center;
    }
    .intro-message {
        padding-top: 50px;
        padding-bottom: 0;
    }
    @media (max-width: 767px) {
        .section-title {
            font-size: 30px;
        }
    }
    .table-element {
        height: 90px;
        border: 1px solid #ffffff;
        padding: 10px;
        display: flex;
        align-items: center;
    }
    .table-element svg, span {
        margin: auto;
    }
    .table-statement {
        background-color: #f6f4f4;
    }
    .table-statement span {
        color: #4a4a4a;
    }
    .table-positive {
        background-color: #d9f5e3;
    }
    .table-positive span {
        color: #43b895;
    }
    .table-negative {
        background-color: #fedede;
    }
    .table-negative span {
        color: #ff637e;
    }
</style>
